export var initDevTools = function initDevTools() {
  window.VCDevTools = function (opts) {
    return import( /* webpackChunkName: "vc-dev-tools" */'./dev-tools').then(function (_ref) {
      var startVCDevTools = _ref.startVCDevTools;
      return startVCDevTools === null || startVCDevTools === void 0 ? void 0 : startVCDevTools(opts);
    });
  };
};